// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const clientInClientMax = 120;

export const ClientIn = zod.object({
  "client": zod.string().min(1).max(clientInClientMax)
});

export type ClientIn = zod.input<typeof ClientIn>;
export type ClientInOutput = zod.output<typeof ClientIn>;
